module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('v-snackbar', {
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarMsg) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("fermer")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "scale-transition",
      "overlay": false,
      "max-width": "290"
    },
    model: {
      value: (_vm.askForSignIn),
      callback: function($$v) {
        _vm.askForSignIn = $$v
      },
      expression: "askForSignIn"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Petite question 🙈")]), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('p', [_vm._v("\n            Votre contribution en tant qu'\n            "), _c('strong', [_vm._v("utilisateur anonyme")]), _vm._v(" est enregistrée. Merci !\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Ça vous dit de vous\n            "), _c('strong', [_vm._v("enregistrer")]), _vm._v(" pour que vos contributions portent votre nom ?\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            C'est trèèès rapide 🚀\n          ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addArea.apply(null, arguments)
      }
    }
  }, [_vm._v("Oui")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.askForSignIn = false
      }
    }
  }, [_vm._v("non")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "scale-transition",
      "overlay": false,
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogAddArea),
      callback: function($$v) {
        _vm.dialogAddArea = $$v
      },
      expression: "dialogAddArea"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Ajouter une aire")]), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('div', {
    staticClass: "pb-3"
  }, [_vm._v("\n            Vous souhaitez ajouter une aire de jeux ? C'est ici que ça se passe.\n          ")]), _vm._v(" "), _c('div', {}, [_vm._v("\n            Un marqueur va apparaître sur la carte. Faites le glisser précisement jusqu'au bon endroit, puis cliquez dessus pour confirmer.\n          ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addArea.apply(null, arguments)
      }
    }
  }, [_vm._v("Ok !")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogAddArea = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "scale-transition",
      "overlay": false,
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogConfirmArea),
      callback: function($$v) {
        _vm.dialogConfirmArea = $$v
      },
      expression: "dialogConfirmArea"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Enregister la nouvelle aire ?")]), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('div', {
    staticClass: "pb-3"
  }, [_vm._v("\n            Vous êtes sur le point d'ajouter une nouvelle aire de jeux à cet endroit. Elle sera visible par tout le monde.\n          ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.authenticateAndCallback(_vm.pushArea)
      }
    }
  }, [_vm._v("Oui, je le veux")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleteArea.apply(null, arguments)
      }
    }
  }, [_vm._v("Non ! La supprimer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogConfirmArea = false
      }
    }
  }, [_vm._v("Revenir à la carte")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "scale-transition",
      "overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogEditArea),
      callback: function($$v) {
        _vm.dialogEditArea = $$v
      },
      expression: "dialogEditArea"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    staticStyle: {
      "flex": "0 0 auto"
    },
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogEditArea = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Ajouter des détails à l'aire")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('EditArea', {
    attrs: {
      "dialogEditArea": _vm.dialogEditArea,
      "equipmentsList": _vm.equipmentsList,
      "uid": _vm.uid,
      "connected": _vm.connected,
      "areaId": _vm.areaId,
      "openAtNightP": _vm.openAtNight,
      "freeAreaP": _vm.freeArea
    },
    on: {
      "editSuccess": _vm.editSuccessActions,
      "askForSignInMsg": function($event) {
        _vm.askForSignIn = true
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "scale-transition",
      "overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogAddComment),
      callback: function($$v) {
        _vm.dialogAddComment = $$v
      },
      expression: "dialogAddComment"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    staticStyle: {
      "flex": "0 0 auto"
    },
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogAddComment = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Ajouter un avis")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('h2', [_vm._v("\n                Cadre\n              ")]), _vm._v(" "), _c('star-rating', {
    attrs: {
      "inline": "",
      "star-size": 40,
      "increment": 0.5,
      "show-rating": false,
      "active-color": _vm.tertiary
    },
    model: {
      value: (_vm.ratingSurroundings),
      callback: function($$v) {
        _vm.ratingSurroundings = $$v
      },
      expression: "ratingSurroundings"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('h2', [_vm._v("\n                Équipement\n              ")]), _vm._v(" "), _c('star-rating', {
    attrs: {
      "inline": "",
      "star-size": 40,
      "increment": 0.5,
      "show-rating": false,
      "active-color": _vm.tertiary
    },
    model: {
      value: (_vm.ratingEquipment),
      callback: function($$v) {
        _vm.ratingEquipment = $$v
      },
      expression: "ratingEquipment"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pt-5"
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "box": "",
      "label": "Commentaire",
      "hint": "Dites ici ce que vous avez pensé de l'aire, donnez éventuellement des infos pratiques..."
    },
    model: {
      value: (_vm.comment),
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  }), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary",
      "loading": _vm.sendingRating,
      "disabled": _vm.sendingRating,
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.authenticateAndCallback(_vm.sendRating)
      }
    }
  }, [_vm._v("Publier")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "id": "bottomSheet",
      "inset": "",
      "hide-overlay": "",
      "persistent": ""
    },
    model: {
      value: (_vm.sheet),
      callback: function($$v) {
        _vm.sheet = $$v
      },
      expression: "sheet"
    }
  }, [_c('v-card', {
    staticStyle: {
      "height": "100%",
      "overflow": "scroll"
    }
  }, [_c('v-card-text', [
    [_c('v-btn', {
      attrs: {
        "fab": "",
        "flat": "",
        "color": "primary"
      },
      nativeOn: {
        "click": function($event) {
          _vm.sheet = false
        }
      }
    }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-container', {
      attrs: {
        "grid-list-md": "",
        "text-xs-center": ""
      }
    }, [(_vm.dist) ? _c('div', {
      staticClass: "pb-3"
    }, [_c('h3', [_vm._v("Aire de jeux à " + _vm._s(_vm.dist) + " "), _c('v-icon', [_vm._v("directions_walk")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.googleMapDirections,
        "target": "_blank"
      }
    }, [_vm._v("Itinéraire")])], 1)]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "pt-3"
    }), _vm._v(" "), (_vm.averageRatingSurroundings || _vm.averageRatingEquipment) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md6": ""
      }
    }, [_c('h3', [_vm._v("\n                  Cadre\n                ")]), _vm._v(" "), _c('star-rating', {
      attrs: {
        "inline": "",
        "read-only": "",
        "star-size": 30,
        "increment": 0.1,
        "show-rating": false,
        "active-color": _vm.tertiary
      },
      model: {
        value: (_vm.averageRatingSurroundings),
        callback: function($$v) {
          _vm.averageRatingSurroundings = $$v
        },
        expression: "averageRatingSurroundings"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md6": ""
      }
    }, [_c('h3', [_vm._v("\n                  Équipement\n                ")]), _vm._v(" "), _c('star-rating', {
      attrs: {
        "inline": "",
        "read-only": "",
        "star-size": 30,
        "increment": 0.1,
        "show-rating": false,
        "active-color": _vm.tertiary
      },
      model: {
        value: (_vm.averageRatingEquipment),
        callback: function($$v) {
          _vm.averageRatingEquipment = $$v
        },
        expression: "averageRatingEquipment"
      }
    })], 1)], 1) : _c('div', [_c('span', {
      staticClass: "font-italic"
    }, [_vm._v("Pas encore de note, soyez le premier à rédiger un avis !")])])], 1), _vm._v(" "), _c('v-container', _vm._l((_vm.comments), function(c, i) {
      return _c('div', {
        key: i
      }, [_c('div', {
        staticClass: "pt-3"
      }, [_c('p', [_vm._v("\n                  " + _vm._s(c.displayName) + ", le " + _vm._s(_vm.getDateFromTimestamp(c.timestamp))), _c('br'), _vm._v(" Cadre\n                  "), _c('star-rating', {
        attrs: {
          "inline": "",
          "read-only": "",
          "star-size": 15,
          "increment": 0.5,
          "show-rating": false,
          "active-color": _vm.tertiary
        },
        model: {
          value: (c.ratingSurroundings),
          callback: function($$v) {
            _vm.$set(c, "ratingSurroundings", $$v)
          },
          expression: "c.ratingSurroundings"
        }
      }), _vm._v("\n                  Équipement\n                  "), _c('star-rating', {
        attrs: {
          "inline": "",
          "read-only": "",
          "star-size": 15,
          "increment": 0.5,
          "show-rating": false,
          "active-color": _vm.tertiary
        },
        model: {
          value: (c.ratingEquipment),
          callback: function($$v) {
            _vm.$set(c, "ratingEquipment", $$v)
          },
          expression: "c.ratingEquipment"
        }
      }), _vm._v(" "), _c('br'), _vm._v(" "), (c.comment) ? _c('span', [_vm._v("\"" + _vm._s(c.comment) + "\"")]) : _vm._e()], 1)])])
    }), 0), _vm._v(" "), _c('v-container', [_c('div', {
      staticClass: "text-xs-center"
    }, [_c('v-btn', {
      attrs: {
        "color": "primary",
        "flat": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.dialogAddComment = true
        }
      }
    }, [_vm._v("Rédiger un avis")]), _vm._v(" "), _c('hr')], 1)]), _vm._v(" "), _c('v-container', {
      attrs: {
        "grid-list-md": "",
        "text-xs-center": ""
      }
    }, [_c('div', {
      staticClass: "pt-3"
    }), _vm._v(" "), (_vm.freeArea === undefined && _vm.openAtNight === undefined && _vm.equipmentsList.length === 0) ? _c('div', {
      staticClass: "font-italic"
    }, [_vm._v("\n              La description de cette aire est inconnue pour le moment. A vous de jouer !"), _c('br')]) : _c('div', [(_vm.freeArea != undefined) ? _c('div', {
      staticClass: "pb-1"
    }, [_vm._v("\n                  " + _vm._s(_vm.freeArea ? 'Gratuite' : 'Payante') + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.openAtNight != undefined) ? _c('div', {
      staticClass: "pb-1"
    }, [_vm._v("\n                  " + _vm._s(_vm.openAtNight ? 'Ouverte la nuit' : 'Fermée la nuit') + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._l((_vm.equipmentsList), function(equipment) {
      return _c('v-chip', {
        attrs: {
          "color": "primary",
          "text-color": "black"
        }
      }, [_vm._v(_vm._s(equipment))])
    }), _vm._v(" "), _c('v-spacer')], 2)]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary",
        "flat": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.dialogEditArea = true
        }
      }
    }, [_vm._v("Suggérer une modification")]), _vm._v(" "), _c('hr')], 1), _vm._v(" "), _c('v-container', {
      attrs: {
        "grid-list-md": true
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((_vm.pictures), function(pic, i) {
      return _c('v-flex', {
        key: i,
        attrs: {
          "xs12": "",
          "md4": ""
        }
      }, [_c('v-card', {
        attrs: {
          "flat": "",
          "tile": ""
        }
      }, [_c('v-img', [_c('a', {
        attrs: {
          "href": pic.src,
          "target": "_blank"
        }
      }, [_c('img', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "src": pic.thumb
        }
      })])])], 1)], 1)
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "text-xs-center"
    }, [_c('input', {
      attrs: {
        "type": "file",
        "accept": "image/*",
        "id": "cameraInput"
      }
    }), _vm._v(" "), _c('v-btn', {
      attrs: {
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.authenticateAndCallback(_vm.takeAPhoto)
        }
      }
    }, [_vm._v("\n                    Ajouter une photo\n                    "), _c('v-icon', [_vm._v("add_a_photo")])], 1), _vm._v(" "), _vm._l((Object.keys(_vm.uploadProgress)), function(ts, progress) {
      return _c('div', [(_vm.uploadProgress[ts]) ? _c('v-progress-linear', {
        attrs: {
          "color": "primary",
          "value": _vm.uploadProgress[ts]
        }
      }) : _vm._e()], 1)
    })], 2)], 1)]
  ], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51e84893","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 455
// module chunks = 1